'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasLinkAccountCookie = hasLinkAccountCookie;
exports.setOldSessionIdInStorage = setOldSessionIdInStorage;
exports.setProviderInStorageForLinkAccount = setProviderInStorageForLinkAccount;

var _cookie = require('cookie');

var _cookie2 = _interopRequireDefault(_cookie);

var _Cookie = require('./Cookie');

var _Cookie2 = _interopRequireDefault(_Cookie);

var _Provider = require('./Provider');

var _SessionStorage = require('./SessionStorage');

var _config = require('../config');

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function hasLinkAccountCookie(realm) {
  var linkAccountCookieName = (0, _Cookie2.default)(_config2.default.envPrefix, _Cookie.linkAccountCookie, realm);
  return (0, _Cookie.getCookieValue)(linkAccountCookieName);
}

function setOldSessionIdInStorage(realm) {
  if (hasLinkAccountCookie(realm)) {
    var parsedCookie = _cookie2.default.parse(document.cookie);
    (0, _SessionStorage.saveDataInSessionStorage)(_SessionStorage.SessionStorageKeys.OldSessionId, parsedCookie[(0, _Cookie2.default)(_config2.default.envPrefix, _Cookie.loginSessionIdName, realm)]);
    var linkAccountCookieName = (0, _Cookie2.default)(_config2.default.envPrefix, _Cookie.linkAccountCookie, realm);
    (0, _Cookie.deleteCookie)(linkAccountCookieName);
  }
}

function setProviderInStorageForLinkAccount(auth, getProviderCallback) {
  if (hasLinkAccountCookie(auth.realm) && auth.userInfo && auth.userInfo.account && auth.userInfo.account.operatorId) {
    (0, _Provider.getProviderRequest)(auth.userInfo.account.operatorId, auth, _SessionStorage.SessionStorageKeys.LinkAccountProviderKey, function (result) {
      getProviderCallback(result);
    });
  }
}


//////////////////
// WEBPACK FOOTER
// ./src/helpers/LinkAccount.js
// module id = 276
// module chunks = 0